import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import type { AnyRoute } from "@tanstack/react-router";

export const createFeedbackRoutes = (parent: AnyRoute) => [
  createRoute({
    getParentRoute: () => parent,
    path: "/feedback/machine_feedback",
    component: lazyRouteComponent(
      () => import("pages/feedback/machine_feedback"),
    ),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/feedback/customer_feedback",
    component: lazyRouteComponent(
      () => import("pages/feedback/customer_feedback"),
    ),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/feedback/machine_feedback_ref",
    component: lazyRouteComponent(
      () => import("pages/feedback/machine_feedback_ref"),
    ),
  }),
];
